import client from '@api/client';

export const signIn = ({ UIDSignature, UID, signatureTimestamp }, callback) => {
  return client.post('/users/login', {
    UID,
    UIDSignature,
    signatureTimestamp,
  });
};
